import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import ProblemsSection from '../components/sections/ProblemsSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import StatisticsSection from '../components/sections/StatisticsSection';
import TestimonialSection from '../components/sections/TestimonialSection';
import CTASection from '../components/sections/CTASection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ProblemsSection />
      <FeaturesSection />
      <StatisticsSection />
      <TestimonialSection />
      <CTASection />
    </main>
  );
}
